module.exports = __webpack_public_path__ + "static/media/2.5f3e895d.jpg";